<template>
  <div class="container">
    <div class="title">药品求购</div>
    <div class="form1">
      <div class="left">
        <div class="item">
          <div class="img"></div>
          <div class="text">告诉我们你需要什么</div>
        </div>
        <div class="item">
          <div class="img img2"></div>
          <div class="text">接收我们反馈的详细信息</div>
        </div>
        <div class="item">
          <div class="img img3"></div>
          <div class="text">达成协议</div>
        </div>
      </div>
      <div class="right">
        <div class="tip">省时间，可免费获取相关药品的信息，快来试试！</div>
        <div class="box">
          <i-form
            ref="drug"
            :model="formValidate"
            :rules="ruleValidate"
            :label-width="80"
          >
            <Form-item label="药品名" prop="drug">
              <i-input
                v-model="formValidate.drug"
                placeholder="请输入药品名"
              ></i-input>
            </Form-item>
            <Form-item label="姓名" prop="name">
              <i-input
                v-model="formValidate.name"
                placeholder="请输入姓名"
              ></i-input>
            </Form-item>
            <Form-item label="邮箱" prop="mail">
              <i-input
                v-model="formValidate.mail"
                placeholder="请输入邮箱"
              ></i-input>
            </Form-item>
            <Form-item label="数量">
              <Row>
                <i-col span="11">
                  <Form-item prop="num">
                    <i-input
                      v-model="formValidate.num"
                      placeholder="请输入数量"
                    ></i-input>
                  </Form-item>
                </i-col>
                <i-col span="2" style="text-align: center">--</i-col>
                <i-col span="11">
                  <Form-item prop="unit">
                    <i-select
                      v-model="formValidate.unit"
                      placeholder="请选择单位"
                    >
                      <i-option value="片">片</i-option>
                      <i-option value="包">包</i-option>
                      <i-option value="小瓶">小瓶</i-option>
                      <i-option value="其他">其他</i-option>
                    </i-select>
                  </Form-item>
                </i-col>
              </Row>
            </Form-item>
            <Form-item label="预算总额">
              <Row>
                <i-col span="11">
                  <Form-item prop="money">
                    <i-input
                      v-model="formValidate.money"
                      placeholder="请输入预算总额"
                    ></i-input>
                  </Form-item>
                </i-col>
                <i-col span="2" style="text-align: center">--</i-col>
                <i-col span="11">
                  <Form-item prop="currency">
                    <i-select
                      v-model="formValidate.currency"
                      placeholder="请选择货币类型"
                    >
                      <i-option value="人民币">人民币</i-option>
                      <i-option value="美元">美元</i-option>
                      <i-option value="欧元">欧元</i-option>
                    </i-select>
                  </Form-item>
                </i-col>
              </Row>
            </Form-item>
            <Form-item label="主体" prop="main">
              <i-select v-model="formValidate.main" placeholder="请选择主体">
                <i-option value="公司">公司</i-option>
                <i-option value="个人">个人</i-option>
              </i-select>
            </Form-item>
            <Form-item>
              <i-button type="primary" @click="handleSubmit()">提交</i-button>
              <i-button
                type="ghost"
                style="margin-left: 8px"
                @click="handleReset"
                >重置</i-button
              >
            </Form-item>
          </i-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BuyDrug",
  data() {
    return {
      formValidate: {
        drug: "",
        name: "",
        mail: "",
        unit: "",
        num: "",
        money: "",
        currency: "",
        main: ""
      },
      ruleValidate: {
        drug: [{ required: true, message: "药品名不能为空", trigger: "blur" }],
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        mail: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" }
        ],
        unit: [{ required: true, message: "请选择单位", trigger: "change" }],
        num: [{ required: true, message: "数量不能为空", trigger: "change" }],
        money: [
          { required: true, message: "预算总额不能为空", trigger: "change" }
        ],
        currency: [
          { required: true, message: "请选择货币种类", trigger: "change" }
        ],
        main: [{ required: true, message: "请选择主体", trigger: "change" }]
      }
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.drug.validate(valid => {
        if (valid) {
          this.$Message.success("提交成功!");
        } else {
          this.$Message.error("表单验证失败!");
        }
      });
    },
    handleReset() {
      this.$refs.drug.resetFields();
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  width 800px
  margin 10px auto
  background #fff
  .title
    height 40px
    line-height 40px
    text-align center
    font-size 14px
  .form1
    margin-top 20px
    display flex
    height 500px
    .left
      width 200px
      background #1880f4
      display flex
      flex-direction column
      justify-content center
      align-items center
      .item
        height 120px
        .img
          width 30px
          height 30px
          margin 10px auto
          background-image url('../../assets/pc/images/index/blform.png')
          background-repeat no-repeat;
          background-position -223px -7px
          transform scale(1.2)
        .img2
          background-position -223px -54px
        .img3
          background-position -223px -100px
        .text
          color #fff
    .right
      flex 1
      border-top 1px solid #ccc
      border-bottom 1px solid #ccc
      .tip
        height 40px
        line-height 40px
        padding 0 20px
        color #666
        font-size 16px
        font-weight 700
        text-align center
      .box
        padding 10px 30px 0 10px
</style>
